// extracted by mini-css-extract-plugin
module.exports =  {"contact-seller-button":"cvkxmnL","contactSellerButton":"cvkxmnL","avatar":"m8b_rYh"};